import React from 'react';
import { Link } from 'react-router-dom';


const AuthHeader: React.FC = () => {
    return (
        <nav className="navbar navbar-expand-lg fixed-top">
            <div className="container-fluid">
                {/* logo */}
                <Link className="navbar-brand" to="/auth/login">
                    <img data-bs-img="light" src={asset('/assets/img/logo.png')} alt="" className="me-2" />
                    <img data-bs-img="dark" src={asset('/assets/img/logo.png')} alt="" className="me-2" />
                    <div className="lh-20">
                        <span className="h4">Dev<span className="fw-bold">UIUX</span></span>
                        <p className="company-tagline">Developer Dashboard</p>
                    </div>
                </Link>

                <div className="ms-auto"></div>
                {/* right icons button */}
                <div className="ms-auto"></div>
            </div>
        </nav>
    );
};

export default AuthHeader;
